module.exports = __webpack_public_path__ + "img/crea.8988f415.svg";